export enum CloudStockLevel {
    NoStock = "NO_STOCK",
    InStock = "IN_STOCK",
    LowStock = "LOW_STOCK",
    UnknownStock = "UNKNOWN_STOCK",
    NoneWithShipToStore = "NONE_WITH_SHIP_TO_STORE"
}
